/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Columnmenu_Clearfilter2Inputs */

const en_columnmenu_clearfilter2 = /** @type {(inputs: Columnmenu_Clearfilter2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Filter`)
};

const de_columnmenu_clearfilter2 = /** @type {(inputs: Columnmenu_Clearfilter2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter löschen`)
};

/**
* | output |
* | --- |
* | "Clear Filter" |
*
* @param {Columnmenu_Clearfilter2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const columnmenu_clearfilter2 = /** @type {((inputs?: Columnmenu_Clearfilter2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Columnmenu_Clearfilter2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_columnmenu_clearfilter2(inputs)
	return de_columnmenu_clearfilter2(inputs)
});
export { columnmenu_clearfilter2 as "columnMenu_clearFilter" }